import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar";
import logo from "../logo.png";

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useApp() || {};
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 980 : false
  );

    const menuItems = [
      { name: "Home", path: "/" },
      { name: "Blogs", path: "/blogs", requiresAuth: false },
      { name: "Bikes", path: "/bikes" },
      { name: "AI Bike Finder", path: "/recommend" },
      { name: "Routes", path: "/routes" },
      { name: "Showrooms", path: "/showrooms" },
      { name: "Shop", path: "/shop" },
/*{ name: "Loans", path: "/loans" },
{ name: "Insurance", path: "/insurance" },*/
      { name: "Calculator", path: "/calculator" },
      { name: "Mechanic Finder", path: "/mechanic-finder" },
      ...(user?.role === "mechanic" ? [{ name: "My Garage", path: "/my-garage", requiresAuth: true }] : []),
      { name: "Compare", path: "/compare" },
      { name: "Rides", path: "/rides", requiresAuth: true, guestLabel: "Rides Premium" },
      { name: "Showroom Owner", path: "/showroom-owner", requiresAuth: true, guestLabel: "Showroom Premium" },
      { name: "Chat", path: "/chat", requiresAuth: true, guestLabel: "Chat Premium" },
      { name: "SOS", path: "/sos", requiresAuth: true, guestLabel: "SOS Premium" }
    ];

  useEffect(() => {
    setSidebarOpen(false);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [location.pathname]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleResize = () => {
      setIsMobile(window.innerWidth < 980);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigate = (item) => {
    if (item.requiresAuth && !user) {
      navigate("/login");
      return;
    }

    navigate(item.path);
  };

  return (
    <div style={layoutShellStyle}>
      {sidebarOpen ? <div style={mobileOverlayStyle} onClick={() => setSidebarOpen(false)} /> : null}

      <aside
        style={{
          ...sidebarStyle,
          ...(isMobile ? mobileSidebarBaseStyle : null),
          ...(isMobile && sidebarOpen ? mobileSidebarOpenStyle : null),
        }}
      >
        <div style={{ padding: "20px", borderBottom: "1px solid #222" }}>
          <img src={logo} alt="MotoHub India Logo" style={{ width: "140px" }} />
          <p style={{ fontSize: "12px", color: "#aaa" }}>
            Ride Together India
          </p>
        </div>

        {menuItems.map((item) => (
          <div
            key={item.name}
            onClick={() => handleNavigate(item)}
            style={{
              ...menuItemStyle,
              ...(location.pathname === item.path ? activeMenuItemStyle : null),
            }}
            className="menu-item"
          >
            {item.requiresAuth && !user ? item.guestLabel || item.name : item.name}
          </div>
        ))}
      </aside>

      <div
        style={{
          ...contentShellStyle,
          marginLeft: isMobile ? 0 : contentShellStyle.marginLeft,
        }}
      >
        <Navbar
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((open) => !open)}
        />

        <main
          style={{
            flex: 1,
            padding: isMobile ? "12px 16px 20px" : "20px 24px",
            width: "100%",
            maxWidth: "100%",
            overflowX: "hidden",
            marginLeft: isMobile ? 0 : undefined,
          }}
        >
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
}

const layoutShellStyle = {
  display: "flex",
  minHeight: "100vh",
  background: "var(--bg)",
};

const sidebarStyle = {
  width: "220px",
  background: "#0d0d0d",
  borderRight: "1px solid #222",
  color: "#fff",
  position: "fixed",
  height: "100vh",
  overflowY: "auto",
  zIndex: 1302,
  left: 0,
  top: 0,
  transition: "transform 0.25s ease"
};

const menuItemStyle = {
  padding: "12px 20px",
  cursor: "pointer",
  borderBottom: "1px solid #111"
};

const activeMenuItemStyle = {
  background: "rgba(232, 76, 30, 0.18)",
  background: "#111",
border: "1px solid #222",
//borderRadius: "12px"
  borderLeft: "3px solid var(--brand)",
  paddingLeft: "17px"
};

const contentShellStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  marginLeft: "220px",
  minWidth: 0
};

const mobileOverlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.48)",
  zIndex: 1301
};

const mobileSidebarBaseStyle = {
  transform: "translateX(-100%)",
  width: "280px",
  maxWidth: "80vw",
  boxShadow: "0 20px 60px rgba(0,0,0,0.45)"
};

const mobileSidebarOpenStyle = {
  transform: "translateX(0)"
};
